var _polygon, _polygon2, _path, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProcessing = function SvgProcessing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,146.6,58.2,138.78l-21.56,7.71c-2.76,1.3-5.17,2.08-5.17,4.65v12.77a48.22,48.22,0,0,0,7.1,25.41,44.27,44.27,0,0,0,19.85,17.53c8.81-2.86,15.39-10.5,19.42-17a48.25,48.25,0,0,0,7.1-25.41V152.92C84.94,149.26,83,147.48,80,146.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.42,199.44a35.18,35.18,0,0,1-15.7-14,38.12,38.12,0,0,1-5.62-20.11v-9c0-2,1.22-3.93,3.65-5.06l17.46-6.53v-6l-21.56,7.71c-2.27,1-5.17,2.08-5.17,4.65v12.77a48.22,48.22,0,0,0,7.1,25.41,44.27,44.27,0,0,0,19.85,17.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.42,206.85A25.56,25.56,0,0,0,62.69,205a38.43,38.43,0,0,0,9.06-7.12,49.53,49.53,0,0,0,6.3-8.46,46.49,46.49,0,0,0,6.89-25.66V153.23c0-5.25-2.7-5.64-5-6.63L58.2,138.78v6l17.66,6.63c2.43,1.14,3.65,3,3.65,5.07v9a38.08,38.08,0,0,1-5.62,20.1,34.36,34.36,0,0,1-15.48,13.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.45,166.58c1.51-2.29,6.28-1.56,9.64-.27,0,0,2.3.76,3.17,1.19h0l7.25-1.84a3,3,0,0,1,1.79.09L65,166a.41.41,0,0,1,.07.73l-5.14,3v.07l5.8,2.85.08,0a4.81,4.81,0,0,0,3.5.25l2.81-.87a.82.82,0,0,1,.44,0,.73.73,0,0,1,.34,1.2l-3,3.19a1.76,1.76,0,0,1-1.83.48l-1.64-.52-8.35-2.77L59.54,178a.3.3,0,0,1-.26.39l-.37,0a1.48,1.48,0,0,1-1.32-.59l-3.93-5.66-9.84-3.26C42.51,168.48,41.94,167.47,42.45,166.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.88,232.11l-4.26.69-11.39-11.45-1.37-8.51s-6.65.67-4.08,11.67,1.28,8.31,1.28,8.31-14,2.32-14.93,3.72c-.7,1,1.16,15,2.23,22.52a8.27,8.27,0,0,0,7.11,7.28,6.09,6.09,0,0,0,1.54,0c3.48-.57,20.84-6.28,20.84-6.28l7.36-1.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.7 227.8 458.79 257.36 451.5 258.54 446.88 229.99 456.7 227.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.68,
    cy: 121.14,
    r: 98.15,
    transform: "translate(17.93 285.57) rotate(-45)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.52,24.67s-.07,0-.14,0a3.63,3.63,0,0,0-.66.07c-.06,0-.75.27-.75.27s-.09,0-.08.06.22.2,1.19-.07C342.61,24.84,342.6,24.71,342.52,24.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,23.86a2.55,2.55,0,0,0,.44-.12s0,0-.06,0-.49,0-.55.05-.15.06-.13.08A.69.69,0,0,0,341,23.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.07,23.52a2.75,2.75,0,0,0,.5,0,5.31,5.31,0,0,0,.64-.07l.52-.09s0,0-.09,0a23.9,23.9,0,0,0-3.05.24l.8,0A3.88,3.88,0,0,1,344.07,23.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.32,23.84l0,0a2.8,2.8,0,0,1,.65-.06l.63-.05.09,0-.12,0a10.74,10.74,0,0,0-3.37.43,13.55,13.55,0,0,0,2.1-.19A.18.18,0,0,1,342.32,23.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.89,24.23l.11,0a1.76,1.76,0,0,0,.2-.09l.35-.14c.07,0,.08,0,.08-.05s0,0-.05,0a3.62,3.62,0,0,0-1.05.24h0s0,0-.16.19C343.41,24.33,343.89,24.23,343.89,24.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.16,25.67l-.1,0h-.29a4.86,4.86,0,0,0-1,.25h0A4.61,4.61,0,0,0,339,25.8C339.11,25.77,339.23,25.71,339.16,25.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.3,27.45s-.06-.07-.26-.11l-.12,0-1.05-.15a6.65,6.65,0,0,0-2.21.29v0c.09.08.23.06.3.17s.05.22,0,.25a9.25,9.25,0,0,1-1.45.46c-.12,0-.13,0-.18,0,0-.28.36-.25.44-.47a2.77,2.77,0,0,0-1.29.3s-.05,0-.05.08c0,.21,0,.41,0,.61s0,.17,0,.25-.18.23-.21.38a.28.28,0,0,0,0,.09c.15.34,2.78-.17,3.59-.56.17-.09.82-.71.57-.79a4.07,4.07,0,0,0-.85-.07c.63-.16,1.29-.2,1.92-.36C338.44,27.82,339.28,27.49,339.3,27.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.07,25.16c1.1-.09,2.14-.48,3.23-.61a5.9,5.9,0,0,0-1.21.3l3.81-.7a.74.74,0,0,0,.33-.12.27.27,0,0,0-.13,0,61.92,61.92,0,0,0-7.37,1.36c.5.1.93-.18,1.41-.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.72,31.87h0a.63.63,0,0,0-.26.05,13.6,13.6,0,0,1-1.53.62c-.91.19-1.18.25-1.26.35l0,0a.75.75,0,0,0,.3.06c.31,0,.35.06.39.11s0,.26.11.35a1.65,1.65,0,0,0,.46.11,3.86,3.86,0,0,0,2.11-.13c.2-.12.08-.91.08-.92A1.15,1.15,0,0,0,330.72,31.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.45,27.07a.52.52,0,0,0-.24-.05,2.86,2.86,0,0,0-1.45.25s0,0,0,0,.15,0,.21.06,0,.07-.12.18-.25.26-.1.27a5.5,5.5,0,0,0,1.26-.4C334.45,27.23,334.58,27.13,334.45,27.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.17,47.17c-.34-1-1.12-1.81-1.43-2.84a10,10,0,0,1,0-2c-.07-.77.12-.9.63-1.15.7-.34.41-.68-.43-1.67-2.73-3.26-2.75-3.32-2.88-3.88l.11-.12h.2c-.66-1.35-3-1.29-2.82-3.33l-.29-.3.18-.26.15,0c-.43-.23-1.71-.77-1.72-.77a11.77,11.77,0,0,0-2.26-.6c-.8-.13-1.27-.85-2-1.13-1-.39-3.26-1.19-4.17-1.46-1.68-.49-1.68-.49-1.92-.43h0a15.44,15.44,0,0,0-2.74-.67h0s0,0-.05,0,0,0,0,0l.06,0a6.9,6.9,0,0,1,1.31.64,12,12,0,0,1-1.26-.45,9.29,9.29,0,0,0-1.25-.39,28.29,28.29,0,0,0-7.91-.71c.12.13.12.13.72.34a5.35,5.35,0,0,1-2.69.26,32.51,32.51,0,0,0-3.86-.06c-1.33.89.81,2.09.84,2.09,5.79,1.57,5.84,1.66,6.11,2.14,0,0,1.63,3.88.22,5.16-.58.53-.58.55-.6.65-.05.36.35.53.36.86,0,.5-.33.94-.24,1.46.81.08,1.68-.48,2.43.23a1.36,1.36,0,0,1,.13,2.18c-.88.52-2,.09-2.85.72A3.83,3.83,0,0,0,371,44.07c0,.39,1.77,9.4,3.63,10.86,4.93,2.87,5.09,2.79,5.56,2.52.78-.43,3.43-4.92,3.45-5,.39-.67.28-1.55.93-2.1.34-.28.37-.28,1.83-.21,4.61.2,4.61.2,5-.55s.62-1.2,1.5-1.32c2.14-.29,4.28.32,6.42,0A17.84,17.84,0,0,0,402,48S402.4,47.87,402.17,47.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.4,37.57c.42-.49.42-.78,0-.86,0,0-1.32-.11-1.73.35-.24.26,0,1.24.14,1.44C346.18,39,347.39,37.59,347.4,37.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.94,23.56c-.3,0-.61,0-.92,0,.94.1,4,.31,4.49.35a49.19,49.19,0,0,1-5.43-.29,1.3,1.3,0,0,0-.71.06,1.85,1.85,0,0,1-.73.74c-.75-.55-3.35-.05-3.46,0,.16.15.39.2.54.37l-.07.09a5.46,5.46,0,0,0,1.45.06c-1.9.31-2,0-2.08-.14-1.22-.39-1.45,0-1.56.25-.85.21-1.75,0-2.57.33a.45.45,0,0,0,0,.11,6.51,6.51,0,0,0,1.66.33c1,.14,2.05-.23,3,.35-.13.15-.13.15-.4.24.63.38,3.17.09,3.16-.52l-.22-.15a8.78,8.78,0,0,1,2.35-.54c2.1.22,3-.27,3.11-.43l-.08-.07a12.23,12.23,0,0,0,3.54.06,1.36,1.36,0,0,0-.47-.11l4.74.17c-1.1-.22-1.16-.23-1.57-.34,1.1.08,2.19.29,3.29.39-1-.34-2.68-.71-2.69-.71s-4.18-.71-5.13-.69a.37.37,0,0,0,.11.19,1.59,1.59,0,0,1-.73-.21c-.27-.14-3.92-.5-4.41-.21C360.32,23.4,360.35,23.43,361.94,23.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.87,24.8a3.92,3.92,0,0,1-.33.27,3.66,3.66,0,0,1-.73.28l.26-.3a.38.38,0,0,0,.11-.14,1.09,1.09,0,0,0-.86.13l.12,0s0,0,0,0a8,8,0,0,1-1.62.16c.06.06.16,0,.21.08s-.09.09-.1.12.07.05,1.52.08a5.88,5.88,0,0,0-2,.54,0,0,0,0,0,0,0s1.66,0,1.88-.06a5.81,5.81,0,0,0,1.23-.45s0,0-.05.12,0,0,0,0a19,19,0,0,1,1.8-.7c.27-.11.29-.11.34-.16s0,0-.14-.05-1.44-.07-1.6,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.39,40.14c.62.16,1.36,2.3,1.37,2.32.17.52.35,1.06.67,1.11.88.14,3.24-2.6,3.27-2.63a1,1,0,0,0,.16-.32l-5.59-3.51a8.32,8.32,0,0,1,2.11-.28c.74-.06,1.11-.09,1.15-.26a7.45,7.45,0,0,0-2.3-3.76c-.43-.23-1-.26-1.34-.64s-.06-1.15-.69-1.42a9.91,9.91,0,0,0-3.09-.2c-1.07,0-1.08,0-1.23-.05a5.2,5.2,0,0,1,.41-1.75,6.06,6.06,0,0,0-2-.57c-2-.21-9,2.44-8.26,3.5s4.53,1.57,5.08,1.51c0-.32.05-.53,1.64-.16,1.34.31,1.64.07,1.85-.1.25.28.83,1.3.84,1.3.27.64.23,1.35.47,2,.31.81,1.54,1.17,1.15,2.32,0,0-1.18,2.52-5.15,2.33-1.19-.06-2.34-.53-3.55-.34a1,1,0,0,0-.73,1c.13.25.74.55,2.86.58,1.62,0,1.62,0,3.79,2-.29.14-.29.14-1.46.17.39.7,4.46,3.15,5.53,3,0-.15,0-.15-.17-.34a19.46,19.46,0,0,1-1.41-2.6,5.4,5.4,0,0,1,2.54,1.95c.12.18.22.31.31.31.54,0,2-1.54,1.75-2.09-.53-1.18-2.16-1.62-2.16-3.18C352.22,40.06,354.37,40.13,354.39,40.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,24.49a1.71,1.71,0,0,0,.78,0l.21-.07h-.05A5.32,5.32,0,0,0,337.56,24.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.26,41.21l1,.14a.73.73,0,0,0,.41-.18.28.28,0,0,0,0-.26c0-.17-.18-.27-.24-.43a.29.29,0,0,1,0-.21s0,0,0-.05A.77.77,0,0,0,370,40c-.45-.05-1.88.22-1.37.85A1.08,1.08,0,0,0,369.26,41.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.92,30.13h0a4.43,4.43,0,0,0-2.21-1.21c-.88-.15-.82.5-.68.73C350.5,30.39,352.89,30.14,352.92,30.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.92,23.49a5.2,5.2,0,0,0-.92.07h.13a2.49,2.49,0,0,1,.86.19c-.09.13-.29.06-.38.2a2.91,2.91,0,0,0,.89,0,4.32,4.32,0,0,0,1.41-.61c-.09-.07-.21,0-.32-.05.16-.15.38-.06.55-.16,0,0,0,0-.08,0a13.72,13.72,0,0,0-2.09.13c.15.1.34,0,.49.1S348.36,23.48,347.92,23.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,26.13c-.21.06-.29.08-.08.34a1.46,1.46,0,0,0,1.47.05c.37-.14,1.18-.54.91-.66l-.11,0A12.84,12.84,0,0,0,343,26.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.55,24.56a0,0,0,0,1,0,0h-.13c-.42,0-.83,0-1.24,0s-1-.09-1.44-.11a3.52,3.52,0,0,0-.63,0,12.82,12.82,0,0,0,2.18.35,2.77,2.77,0,0,0,1.12-.15A.44.44,0,0,0,352.55,24.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.19,24.12s0,0,0,0,1.63-.05,2.06-.1c.19,0,.23,0,.26-.1s-.11-.09-.08-.17.05-.07,0-.11,0,0,0,0a.08.08,0,0,0,0-.06c-.05,0-.09,0-.18,0a.84.84,0,0,0-.23,0,4.42,4.42,0,0,1-1,.36C349.5,24,349.34,24,349.19,24.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.87,23.23a4.9,4.9,0,0,0,1.11-.16s-.07,0-.1,0-1,0-1.34,0-.29.19-.29.19A1.43,1.43,0,0,0,352.87,23.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,23.5c.43,0,.56,0,.67.13a.05.05,0,0,1,0,0,3.29,3.29,0,0,1-.72,0,9,9,0,0,0-1.57,0c-.29.06-.41.34-.32.42s0,0,.77.06a8.2,8.2,0,0,0,.86.18c.74,0,1.45-.23,2.18-.29.45,0,.9.06,1.35,0a.2.2,0,0,0,.11,0s0,0-.28-.19v0a1.6,1.6,0,0,1,.23,0c.63-.07.64-.09.67-.14s-.12,0-.16-.1c.13-.09.34-.05.37-.26s.36-.08.52-.19l-.11,0a30.68,30.68,0,0,0-3.69.06,1,1,0,0,0,.38.07,2.69,2.69,0,0,1-1,0,2.25,2.25,0,0,0-1.3.2A5,5,0,0,0,355,23.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,27c.06,0,6.92,1.67,9.29.55.64-.31-.51-.79-.52-.79a27.29,27.29,0,0,0-4.64-.22c-.63,0-.88-.63-.72-.73s.17,0,.39,0c1.18.07.77-.45.66-.5a4.91,4.91,0,0,0-.85-.09c-.33-.08-.59-.3-.92-.38a6.25,6.25,0,0,0-.64-.11,2.14,2.14,0,0,0-.94.51,1.32,1.32,0,0,0,.44.05c.34,0,.79,0,.86.09s-.64.65-.67.67c-.43.19-.93.14-1.34.37C344.89,26.82,345.13,26.9,345.31,27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.24,25.05h0c-.25,0-2.29.42-2.41.5C331.93,25.58,332,25.61,334.24,25.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.21,28.81a.08.08,0,0,0,0,.05.24.24,0,0,0,.12,0c.68-.19,1.31-.48,2-.67,1.21-.34,2.45-.53,3.66-.9.28-.08.28-.08.75-.51v-.07a3.39,3.39,0,0,0-1.05.16c.32-.13.32-.13.42-.29l0,0H328c-1.37.08-1.37.08-8.18,2.57a3.91,3.91,0,0,0-1.72,1.05l0,0A19.38,19.38,0,0,0,322.21,28.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,26.4a3.83,3.83,0,0,0,1.12-.11c2-.34,2.92-.41,2.92-.41.6,0,1.2,0,1.8-.05s2.35-.59,2.37-.6c.36-.1.4-.13.45-.17a1,1,0,0,0-.5,0c-.56.1-1.09.32-1.64.43.77-.37,1.6-.59,2.36-1h-.07a9.87,9.87,0,0,0-2.4.55c-.11.18-.54.57-2.1.4a.08.08,0,0,0,0,0l.16-.09.05,0c.27-.15,1,0,.82-.44,0,0-4.57.5-4.79,1,0,0,0,0,2.23-.36-.29.24-.68.22-1,.34,0,0,.06,0,.6-.06a4.57,4.57,0,0,1,.94-.07,28.13,28.13,0,0,1-3.05.45C331.29,26.17,331.23,26.33,331.37,26.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.25,32.2c.26.17.56,0,.82.11l0,.06c-.24.29-.63.37-.9.61a16.08,16.08,0,0,0,5.21-.79,3.47,3.47,0,0,1,1.16-.31l.05.05c-.21.19-.21.19-.24.24a5.66,5.66,0,0,0,1,.72c1,0,1,0,2.29-.68l.07,0c-.1-.05-.1-.05-1.12.11a2.34,2.34,0,0,1,2-.39c.22.09.27.09.37.06s.62-.26.68-.67c-.39-.45-.4-1.06,0-1.29a26.29,26.29,0,0,0,3.21-2.17,1.79,1.79,0,0,0-.26-.2v-.11h0c-1.2.46-2.22,1.33-3.52,1.57.06-.48.57-.46.81-.74l-.06-.08a9.89,9.89,0,0,1-1.44.14A4.86,4.86,0,0,0,328,28s0,0,0-.06c-.67,0-1.29.28-1.94.3a15.61,15.61,0,0,1,1.76-.68c-.38-.09-6.21,1.31-6.29,1.92a1.22,1.22,0,0,1,.15.17c-.15.12-.16.12-.84.27-1.14.24-1.23.33-1.27.47a.27.27,0,0,0,.17.08c.56.09,1.11-.12,1.68,0,.4,0,.71.34,1.11.39a6.46,6.46,0,0,1-2.24.22C317.48,30.92,316.85,31.94,317.25,32.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.66,45.81c.16-.18-.06-.25-.23-.28a2.31,2.31,0,0,0-1,0,.8.8,0,0,0-.39.83C335.2,46.72,336.45,46.06,336.66,45.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.8,42.17a.4.4,0,0,0,.22-.08.56.56,0,0,0,0-.57c-.1-.2-.28-.36-.37-.57a7.43,7.43,0,0,0-.39-1.12,1,1,0,0,0-.12-.17c-.23-.29-.61-.38-.85-.67s-.06-.45-.21-.64a.14.14,0,0,0-.09,0,9.38,9.38,0,0,0-1.75,1c-.18.13-.41.3-.58.44l-1.59,1.28c.58.26.58.26.52.58s-.07.4,0,.41a2,2,0,0,0,.72-.22,4.61,4.61,0,0,1,2.6-.39C335.59,41.61,336.09,42.17,336.8,42.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,44.18a7.13,7.13,0,0,0-2,0c-.32.11-.56.66-.45.82s2.22-.11,2.69-.47C334.4,44.42,334.48,44.26,334,44.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,118.18c-.58,0-.57.93-.3,1.15s1.42.86,1.59.3C300.34,119.3,299.67,118.27,299,118.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,59.46a.36.36,0,0,0,0-.11,1.93,1.93,0,0,0-.55-1l-.18-.15a14.55,14.55,0,0,1-1.62-.83c-.33-.3-.49-.78-1-.92s-1.17,0-1.75-.08a15.76,15.76,0,0,0-1.67-.29c-.37,0-.27.48-.58.54s-.51-.34-.85-.27l-.16,0c-.27.43,0,1.1-.69,1.33a7.33,7.33,0,0,1-1-1.93c-.15-1-1.83-2.16-2.5-1.93,0,.48.55.57.67,1-.36.56-1.05.2-1.5.53.13.19.74.31,1.09.36.62.1,2.22,1.38.91,1.86.25.69,1,.44,1.43.75s.4.52.25,1c.08.15.17.23,1.23.48a6.74,6.74,0,0,1,1.15.32c.48.2.86.58,1.33.78l.21.08a8,8,0,0,0,1.89.28c1.33.14,3.69-.56,3.73-1s-.13-.54-.11-.81C408.86,59.4,408.86,59.4,409,59.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.4,116.57c.29.89,3.57,2.32,3.77,2s-2.47-6.7-2.5-6.75a5.49,5.49,0,0,0-4-2.23,6.52,6.52,0,0,0-2.87.6,3.23,3.23,0,0,0,2.28.25c1.5-.27,2.2.42,2.2.67s-.34.22-.66-.15l-.06,0c-.16.62.75,1.22,1.36,1.62,1.11.74,1.1,1,1.08,1.89a2.73,2.73,0,0,0,.13,1.1,1.46,1.46,0,0,1,.14.63C302.13,116.61,301.67,116.42,301.4,116.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.31,122.59c.28.32-.22.86.26,1.09.83.39,1.14-.81,1.9-.62a1.5,1.5,0,0,1,.4.18,34.75,34.75,0,0,0,3.51,1.56c.11,0,.19,0,.24-.08.15-.37-.05-.8.19-1.16.74-1.13-5.35-3.87-5.76-4a.33.33,0,0,0-.19,0c0,.09,0,.09,0,.21a1.89,1.89,0,0,1-.09,2.1c-.15.06-.63-.2-1.27-.56-1.2-.65-1.34-.65-1.42-.65s0,.06,0,.08C303.74,121.56,304.69,121.87,305.31,122.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.77,68.38c-.62,0,.4,1,.62,1.25,1.35,1.32,2.2.7,2.21.69C347,70,344.39,68.49,343.77,68.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.54,47.41l.06,0,0,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.65,36.71,275.86,61.32c-8,9.75-13.49,23.76-13.49,23.76v2.74c.23.12.23.12,1.36,9.81-.29-.09-.67-.22-1-.3.13,1.19,2.08,7,2.09,7.09.5-.36,1-.73.18-3.63-.37-1.32-.79-2.81-.19-9.09a4.77,4.77,0,0,1,1.08,4,8,8,0,0,0-.06,2.43c.32,1.42.84,2.77,1.22,4.18.49,1.82,1.92,3.24,2.19,5.14.23,1.54-.71,3.16.34,4.64a4,4,0,0,0,.6.57,13.32,13.32,0,0,0,1.12,1c1.3.88,2.7,1.62,4,2.48s3.22.58,4.38,1.91c2.66,3.06,2.66,3.06,3.78,3.6l.55.27c5,2.56,4.85,9.78,10.64,11.58,4-3.35,3.81,2.29,3.53,4.87-.09.81-.09.81-2.62,3.45,0,0-3.4,5.21-3.18,6.47a5.25,5.25,0,0,0,.13.69c.89,3.44,5.91,13.74,5.95,13.82,1.31,2.28,3.73,3.54,5.21,5.66,1.13,1.61,1.51,4.14,1.07,7.11,0,.13-1.71,14.39.88,23.41,3.29,11.44,9.94,12.63,10,12.64-5-5.25-5-5.25-3.49-7.62-.52-1.19-.52-1.19-.58-6.13.28,0,.28,0,1.41.45,0-.12,0-.12-.68-2.52,1.39-.57,1.4-.57,1.58-1.35l.29-.1c1.7,1.28,2.89-.07,2.66-1l-.28-1c4.31,1.39,9.77-8.32,9.82-8.43a6,6,0,0,1,3.73-1.36c1.74-.1,2.39-1.87,3.8-2.47a1.52,1.52,0,0,1,1.42.05c.6.3.65.32.94-.24.63-1.24,1-2.58,1.49-3.86.29-.72.12-1.62.85-2.16s1.16-.85,1-1.53a1.32,1.32,0,0,1,0-.44c4,0,6.67-3.47,6.69-3.51a.38.38,0,0,0,0-.15c.08-.45-.16-.89-.09-1.35.1-.68,1.27-1.26.6-2-.47-.5-1.2-.27-1.73-.59-1.72-1.07-2.38-3.12-4-4.3-2.38-1.75-5-3.19-7.42-4.82-1.37-1.12-.87-3-1.47-4.37-1.27-1.65-1.89-3.82-3.27-5.41-1.8-2.08-4.73-2.61-6.48-4.75-1.39-1.69-1.94-3.93-3.51-5.5a3.83,3.83,0,0,0-.87-.64c-8.68-4.6-15.53-8.23-18.9-1.26-2-2.88-10.1-2.28-7.87-6.57a8.33,8.33,0,0,0,.88-5c-1.75-1.82-4.3-1.46-6.39-2.35,1.53-2.1,1.53-2.1,1.4-3.37a13.2,13.2,0,0,0,2.72-3.68c-.28-.5-2.84-4.63-6.43,3.16-1.2-.51-2.6.93-3.72-.37a10.38,10.38,0,0,1-2.86-7.24c.09-1.73,1.83-2.49,2.32-4,.31-1-.8-1.85-.09-2.82.93-1.24,4.43-3,5.19-3.22,1.38-.45,5.23,2,5.26,2l.48-.18c-.19-.46-.62-.75-.89-1.16l.26-.43c1-.19,7.87,1.57,7.89,1.6,2.32,2.52-.83,5.91,1.35,8.46,4.42-2.27.3-7.11,2.08-10.35s5.68-2.91,8.45-4.48l-.05,0-.17-.43.2-.41.46,0,.23-.5c-.11-.08-.25-.2-.35-.29l2.94-6.27c-.29,1-1.32,3.9-1.32,3.91.37-.09.37-.09,2.15-4.28a5.56,5.56,0,0,1,.28,1.61c.94-.8,1.21-2.18,2.42-2.74,0,0,4.58-.75,4.86-.63,1.54-3.23,1.54-3.23,4-4.33.31.13.31.13,6.89-1.12l-.32.32a3,3,0,0,0,.91.55l-.16.47c-4,1.13-4,1.13-4.23,1.77,2.13.79,10.07-.72,9.94-4.11-1.12.29-1.55,1.4-2.38,2-.64-.45-1.16-.81-1.58-1.12a1.66,1.66,0,0,0,1.05-.32s0,0,0,0,0,0,0,0,0,0-.18-.05a2.59,2.59,0,0,1-1.45-.67.75.75,0,0,1-.18-1c.06-.13,0-.15,0-.17h0a1.71,1.71,0,0,0-.5,1.21c-.69-.68-.68-1.14-.65-2.25-.68-.56-.71-.64-.89-1.16,1.27.09,2.18.16,2.83-.91-.39-.8-.39-.8-10.44,1.46,7.75-3.9,7.75-3.9,14.19-3.62,1,1.37,8,.51,9.5-.83,0-.82,0-.82.76-1.73,0-.19,0-.28-.07-.47l-1.38-.84-.41-.15a6.32,6.32,0,0,0-3.13.18c0-.14,0-.32,0-.46.72-.51,1-.52,3-.58h0a.83.83,0,0,0,.35-.1c.15-.18-.81-1.84-2.7-2-.43,0-.43,0-.61-.17,0-.38.4-.66.27-1.06-.17-.55-.86-.67-1-1.22-.07-.24.08-.37.47-.63.56-.4.56-.4.25-2.18-.78-4.49-.78-4.49-2.49-2.89-.27.25,0,.71-.35.92s-.85-.27-1.28,0c-1,.67-1,.67-1.17.66-1.26-.06-1.73-1.26-2.65-1.83a4.54,4.54,0,0,1,1.82-2.55c-.51-.39-1.23-.33-1.73-.74-.12-.1-.17-.22-.25-.59,0-.13-.08-.43-1.35-1.4a1.2,1.2,0,0,0-.6-.3c-1.44-.11-2.74-.89-4.21-.81-.2,1.3-2.08,1.87-1.51,3.49-.41.53-1.25.46-1.54,1.14s.32,1.56.08,2.35c0,0-1.06,3.18-3,3-.43,0-1.43-.08-1.47.65a2.49,2.49,0,0,1-.65.26c-1.12,1.65-.72,4.34-3.3,5-.3-1.22-1.35-1.91-2-2.87a3.17,3.17,0,0,0,.92-2.6l.66-.24c0-.08.08-.23.09-.32a4.71,4.71,0,0,0-.52-.21c-.56-1.13-1.85-.74-2.68-1.31s-1-1.7-1.78-2.33a3.88,3.88,0,0,0-.47-.32c-.77-.42-1.57,0-2.34-.07-.18-.29-.18-.29.16-2.26.12-.69.12-.69-1.37-1.35.35-2.11,6.45-4,9.06-4.81,0-.72-.81-.68-1.09-1.13,4.27.7,4.27.7,7.41-.94-1.65-.27-2-.33-3-1.5,1.68,0,3.28,1.61,5,.26a1.13,1.13,0,0,0-.38-.31s1.07-.64,1.67.13c2.94,0,2.94,0,3.84-.39a2.77,2.77,0,0,0,.6-.35c.45-.37.16-1,.58-1.43s.92-.12,1.35-.34c.24-.15.37-.42.57-.62,0,0-1.42-3-3.28-.12-1.62.3-3.71,3.13-4.83,1.08.48-.92,2.68-.86,2.1-2.15-1.19,0-2,.93-3,1.35,0-.6,1.55-1.61,1.57-1.62a6,6,0,0,0-1-.41c2.53-2,2.53-2,2.65-2.36l-.19-.26c1.43-1.11,1.43-1.11,6.64-2.13a2.08,2.08,0,0,0-.8-.23c-3.74-.4-10.69,4.44-10.75,4.49s0,.2,0,.28c.37.13.76.18,1.14.29a1.94,1.94,0,0,0,0,.24,4,4,0,0,0-1.52.35l-.07.18h0l.21.12c-1.19,1-3,.88-4,2.06-.35-.78-.35-.78,1.1-1.54-.55-.37-.55-.37-3.07.49-.14,0-.94.23-3.33-.73-.08-.29.06-.58,0-.87-2.14-.18-3.12.75-5.09,2.62,0-.65.66-.95.79-1.53-1.12-.2-2.3.36-3.39-.22.63-.3,1.46-.21,1.92-.88-.06-.1-.07-.12-.14-.22-.31,0-.36.06-1.08-.29a2.22,2.22,0,0,0-.2-.48c-.57-.08-1,.27-1.56.41a5.19,5.19,0,0,1,.46-.36,5.51,5.51,0,0,0-1,.4,5.63,5.63,0,0,1,1.49-1.08l-1.73.66s-9.32,5.87-13.06,9.2A119.85,119.85,0,0,0,275.86,61.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.44,126c-.62.17-.2,1,.38,1.37a5,5,0,0,0,2,.4c.06-.06,0-.27-.92-1S313.7,126,313.44,126Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.73,85.85a8,8,0,0,1,.94-.23c.38-.05.77.22,1.14,0,.21-.15.31-.62.31-1.41a3.62,3.62,0,0,0-.16-1,.82.82,0,0,1,.23-1,1.33,1.33,0,0,0,.39-.8,1.39,1.39,0,0,0-.32-1,2.59,2.59,0,0,0-.31-.35c-.27-.27-.6-.47-.87-.74a1.09,1.09,0,0,1-.28-.36s0-.05-.05-.06-2.41-.23-1.34,1a.65.65,0,0,0,.29.2.59.59,0,0,1-.23,0,3.93,3.93,0,0,0-1.59.4.89.89,0,0,0-.51.7.86.86,0,0,0,.29.67c.22.23.55.28.8.45l-.06.07a10.3,10.3,0,0,0-1.33,1.81c-.28.5-.33.76-.23,1C416,85.81,417.47,86.15,418.73,85.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.47,117.67a.35.35,0,0,0,.26,0s.55-.31.56-.33-.14-.38-.61-.61-1.4-.42-1.21.08A2.35,2.35,0,0,0,430.47,117.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.7,84.21c-.1,0-.1,0-.11.14l.62.27A1.73,1.73,0,0,0,423.7,84.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.57,99a12.46,12.46,0,0,1,2.33,4.41c-.53-2.48-1.16-5.79-1.79-8.24-3-9.76-3-9.94-5.21-15l-2.42-5.13v0c-.09-.18-.19-.36-.29-.53a22,22,0,0,0,1.11,2.55,8.56,8.56,0,0,1-.59-.85,9.76,9.76,0,0,0,1.19,2.53l-.17,0c-1.88-3.07-3.21-6.43-5.12-9.47,1,1.29,1.65,2.88,2.86,4a39.38,39.38,0,0,0-5-8.17,14.2,14.2,0,0,1-1.77-2.34,2.51,2.51,0,0,1,.31.26,6.31,6.31,0,0,0-.66-.88l-.18.06a10.18,10.18,0,0,1-1.39-1.67l.33.26c0-.58-2-2.47-2.14-2.58a1.89,1.89,0,0,0,.24.89c-.71-.56-.82-1.56-1.52-2.13,0,.42.36.74.39,1.15-.52.54-.52.54-.61,1a35.11,35.11,0,0,0,.59,4.6c.65,2.64.33,3.37.29,3.44-1,1.9-1,1.9-2.35,2.3-.5.15-.54.3-.51.9,0,.08.53,8,3.68,7.67,1-.1,1.08-1.69,1.11-2.46.17.24,3.32,6.76,3.69,8.6.18.88.35,1.7,1.09,2a5.78,5.78,0,0,0,.82-3.14c-.37-2.38,0-2.52.68-2.83.19-.47.19-.67-.89-2.1-.74-1-.74-1-1.32-3.58-.21-1,1-1.72.51-2.76A18,18,0,0,1,433.58,69c0-.08,0-.2,0-.29l.15-.11c.64.49,2.5,2.94,2.5,3.5L436,72c.41,4.84.41,4.84,1.6,7.11,1,2,3.47,2.59,4.52,4.56a4.07,4.07,0,0,1-.64-.54l-.18,0c0,.22.1.43.14.64A19.73,19.73,0,0,0,439,82.09c.53,1.77,1.63,3.34,1.87,5.22-1-.4-.55-1.89-1.67-2.19l-.17.13s.44,2.69.51,2.9.54,1.61.32,2.06c-.6-.27-.6-.27-.73-.28-.15.16-.26.36-.41.52,0,.06,0,.13.06.18h0c-2.78-1.2-2.78-1.2-2.9-.93l-.48.1a7.7,7.7,0,0,0-1.88-1.46l1.29.72A3,3,0,0,0,433,87.78c-.39-.12-.48-.14-1.11-1.73-.47-1.17-.93-2.8-.49-3.89.18-.46.17-2.65-.33-2.89-.06,0-1.54-.55-1.54.26a35.58,35.58,0,0,0,1.53,6.37,3.47,3.47,0,0,1,.33,1c-.1,0-.12.06-.55,0l-1-.17a23.67,23.67,0,0,1-2.46-3.18,9.94,9.94,0,0,0-.88-1.9A5.1,5.1,0,0,0,424.45,80h0c.76-.32,2.43-2.61.89-3.22a6,6,0,0,0-.84-.23c-1-.22-1.22-.26-1.14-.52.17-.52,1.39-1.18.69-1.48,0,0-2-.64-2.49-.06a.65.65,0,0,0-.06.24c-.12.64.13,1.28,0,1.92s-.65.86-.63,1.44c.13.12.47.19,1.33-.08.32-.11.59-.19.73,0,.56.63-.52,1.1-.47,1.74a2.33,2.33,0,0,0,1.27,2.08c1,.69,1.16.78,1.32,1,0,.19-.19.34-.16.55.12.65.53,1.21.6,1.87s-.66,0-1.1-.38c-.19-.19-.19-.19-.81-.46,0,.83.71,1.48.59,2.34-.06.46-.54.55-1.22.62-.17,0-.45,0-.42.26s.16.49,1.55.93c.59.19,1.8.58,1.72,1a3,3,0,0,0-1.05-.1.74.74,0,0,0,0,.16.79.79,0,0,0-.52.08c-.39.16-.58.57-.95.77s-1,.31-1.41.55c0,0,0,.08,0,.12a6,6,0,0,0,1.56.41,2.4,2.4,0,0,1-.42.59c-1.42-.58-1.6-.84-2.07-1.52a10.2,10.2,0,0,0,.27,1.09l-.32.43a8.36,8.36,0,0,1-1.12,0c-.55-.7-.55-.7-1.68-1.13l-.36.37.66,1.18-.49.14c6.15,4.29,2.68,10.76,2.62,10.81-3.1-1.34-5.83-3.37-8.87-4.8a4.79,4.79,0,0,0,.31,1.06c0,.09-2.66,8.68-1.68,9.38-1.21,2.51-1.21,2.51-1.35,2.73a11.23,11.23,0,0,1,3.61,1.27c-.16,1.63-.16,1.63-.15,1.66l5.78.1c1.49.33,2.48-1.36,2.14-2.84,2-3.12,2.06-3.12,4.49-3.21,1-2.73,1-2.73,1.29-2.84,1.27-.48,1.58,1.11,2.5,1.43,1.37-1.19,2.4-1.91,3.32-.32a113.64,113.64,0,0,1,3.91,11.33,1.88,1.88,0,0,0-.22,1.14c.1.24.48.27.44.62s-.26.57-.28.89a.39.39,0,0,0,.2.4.23.23,0,0,0,.1,0c-.21,1-.89.82-3.43.3a16.51,16.51,0,0,0,1.53,3.48c.55-.74.32-1.71.76-2.48l.43.22c.58-.44,1-1.06,1.53-1.52v-.08a1,1,0,0,0,.64-.6,2.63,2.63,0,0,0,.08-.3c.07-.34.06-.7.12-1,0,0,0-.05,0-.07.09.29.19.63.28.89a2.44,2.44,0,0,0-.15-1.37,5.44,5.44,0,0,0,.15-.54c.11-.58-.06-.72-.25-.81a1.75,1.75,0,0,0-.38,0l-.68-1.82c.08-.11.17-.26.25-.38a.73.73,0,0,0,.05.2s.45,1.18.49,1.22c.2,0,.52-1.44.62-2.19a9.23,9.23,0,0,0,.06-1.09l1.19,3.1s0,0,0,6.71l.43,5.81a8.78,8.78,0,0,0,.41-.95,18.53,18.53,0,0,0,.52-3.7c.56-4,.56-4,1-4.16a3.81,3.81,0,0,1,1.64,2.9,6.21,6.21,0,0,0,.71-.74l.51.14c1.65-3.25.25-7,1.87-10.3a1.39,1.39,0,0,1,.86.36l-.34.35a3.67,3.67,0,0,0,.78,1.32,2.74,2.74,0,0,1-.56,1.52,18,18,0,0,1,.44,2.06c2-.38.12-2.91,1.09-4.13.79.1.83.39.84,1-.12.1-.28.24-.39.35a5.36,5.36,0,0,1,0,2.1l-.41.3c.16,3.33,2,6.54.71,10l-.49.09c-1.08-1.45.09-4.56-2.42-4.77a1.55,1.55,0,0,1-.64.72,7.73,7.73,0,0,0-.83-.58,1.82,1.82,0,0,0,.17.92c-.69.27-1.3-.26-2-.17a6.22,6.22,0,0,0-.43,1l.39.28c-.38,1.82-1.09,5.21.42,7.78l.45-.22c0-.15.1-.34.15-.48.49.83.38,1.89,1,2.67a4.4,4.4,0,0,0,.55-.87,2.72,2.72,0,0,0,.59.8c-2,6.72-2.26,7.76-3.61,9.28-.92-.41-1-.67-1-1.7a1.41,1.41,0,0,0-.93.05c-3.07-1.34-1.17-5.82-4.44-7-1,.88-1,2.32-1.78,3.29l-.51,0c-.51-.74-5.43-9.86-5.65-10.91-.06-.32.32-.73.58-.93.62-.49.62-.49,1.68-4.49a14.22,14.22,0,0,0-1.11-1.36c-.81.26-.81.26-3.25-1.28a4.86,4.86,0,0,0-.92.57c-3-2.55-7.07.24-10.07-2.14l-.49-.22c-1-.14-1.39-.19-2-1.82-.14-.19-.15-.2-.16-.2a3.93,3.93,0,0,0-.56.24c-.92.56-.82,1.84-1.73,2.41-1.13.71-2.59.18-3.68,1-.33.24-.43.84-.58,1.21-1.68,4.08-1.68,4.08-3,4.22a13.22,13.22,0,0,0-3.7,1.14c-1,.78-8.34,7.12-8.35,7.12-.93,2.06-.15,4.34-.85,6.43-.58,1.75-3.35,1.71-3.28,4,.12,3.44.77,6.81,1.14,10.22.15,1.43,3.08,7.19,3.94,7.4,4.28,1.06,8.83.91,12.92,2.86a.86.86,0,0,1,.32.36c.54.91-.41,1.87.11,2.78s1.57.92,2.31,1.47c0,1.84,0,1.84-1.27,3.19-3.44,3.76-3.44,3.76-3.59,5.12-.25,2.15-.58,5.1-5.24,10.19-2.14,2.35-5.09,3.58-7.52,5.54-2.26,1.82-3.41,4.59-5.58,6.49-8.42,7.4-8.62,7.5-9.75,8.06a6.36,6.36,0,0,0-2.25,1.72c2.37,1.76,6.24.73,7.51.39l5.12-1.45,6.66-2.32c1.6-.81,2.87-2.17,4.53-2.88,1.9-.83,4-.8,5.94-1.65,4.53-2,9.93-7.39,10.54-8.07,2.44-2.74,8.65-6.07,10.47-7,2.91-1.59,7.85-6.69,9.39-8.83-.47-.36-.47-.36-1.48-.49-.11-.37-.11-.37,1.67-4a33.23,33.23,0,0,0,1.3-4.26c1.2-3.68,3.19-7,4.14-10.82l3.08-11.84c.1.44.1.44-.24,2.19a2.09,2.09,0,0,0,.85-.74c-.7,9.51-6.25,17.33-9,26.12,1.11-.11,1.11-.11,1.51.13,4.42-4.55,4.42-4.55,4.79-5.2l-.27.49c.16-.27.37-.63.51-.9l.16-.3,1-1.91c.44-.88,1-2,2.3-5-.07.17-.12.32-.18.47,1.07-2.66,2.43-6,3.32-8.57s1.89-6.25,2.55-9c.16-.83.3-1.6.44-2.31.1-2.31.16-2.66,1.52-10.47a.43.43,0,0,0,0,.11c.5-11.11.5-11.11.62-11.61a.14.14,0,0,1,0,.06,61.46,61.46,0,0,0-.42-8.4l-1-7.47A13.58,13.58,0,0,0,447.57,99ZM428.91,86.69s.06,0,.43.24l-.48-.19h0S428.89,86.71,428.91,86.69ZM438,113.28l0,.06a6.08,6.08,0,0,0-.3,1,.74.74,0,0,1-.49.52c-.1,0-.21.09-.24.27v0c-.95-.9-1.71-1.69-2.57-8.94a1.77,1.77,0,0,1,.91-.33l2.8,7.27A.19.19,0,0,0,438,113.28Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.4,476.75c0,.14-98.68.26-220.39.26s-220.41-.12-220.41-.26,98.66-.26,220.41-.26S467.4,476.61,467.4,476.75Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locator--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.24,64.69a20.2,20.2,0,1,0-37.6,10.2h0l.05.08c.78,1.3,1.75,2.24,2.73,3.61l11.73,15.53a3.65,3.65,0,0,0,5.82,0l11.53-15.28A43.07,43.07,0,0,0,356.42,75l0-.06h0A19.94,19.94,0,0,0,359.24,64.69Zm-20.19,8.79a8.89,8.89,0,1,1,8.88-8.88A8.89,8.89,0,0,1,339.05,73.48Z",
    style: {
      fill: "#37474F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Passport--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368,293.54H468A8.47,8.47,0,0,1,476.5,302V435.66a8.47,8.47,0,0,1-8.47,8.47H368a0,0,0,0,1,0,0V293.54a0,0,0,0,1,0,0Z",
    transform: "translate(108.59 -95.87) rotate(14.84)",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.8,398.4a21.92,21.92,0,0,1-5.72-.75,22.38,22.38,0,0,1-13.94-10.95A24.26,24.26,0,0,1,403,368.64c3.38-12.75,16.11-20.48,28.37-17.23a22.38,22.38,0,0,1,13.94,10.95A24.58,24.58,0,0,1,436.61,395,22.58,22.58,0,0,1,424.8,398.4Zm.85-46.08a22.15,22.15,0,0,0-21.09,16.74,22.63,22.63,0,0,0,2,16.84,20.74,20.74,0,0,0,29.17,7.73A22.6,22.6,0,0,0,445.85,380h0a22.61,22.61,0,0,0-2-16.83A20.75,20.75,0,0,0,430.91,353,20.27,20.27,0,0,0,425.65,352.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.36,
    y: 351.58,
    width: 1.65,
    height: 44.67,
    transform: "translate(-45.18 689.11) rotate(-75.16)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.53,
    y: 373.56,
    width: 46.15,
    height: 1.65,
    transform: "matrix(0.26, -0.97, 0.97, 0.26, -46.09, 688.87)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.05,397.3l-.79-1.45c6.16-3.35,10.46-6.71,13.51-10.57a26,26,0,0,0,5.29-17.18c-.49-5.75-3.81-11-6.75-15.56l1.4-.89c3,4.76,6.48,10.15,7,16.31a27.41,27.41,0,0,1-5.65,18.35C428.87,391.61,423.05,395.12,419.05,397.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,397.16c-3.26-4.65-6.4-9.84-7.38-16.21a27.4,27.4,0,0,1,4.19-18.73c3.49-5.08,9.74-8.37,14.77-11l.77,1.46c-4.86,2.56-10.91,5.74-14.18,10.48a26.05,26.05,0,0,0-3.91,17.55c.92,6,4,11,7.09,15.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.34,366.76a49,49,0,0,1-28.83-9.37l1-1.34a47.29,47.29,0,0,0,34.37,8.6l.24,1.63A46.37,46.37,0,0,1,439.34,366.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.63,392.88c-10.94-8-23.52-11.7-34.51-10.13l-.24-1.64c11.42-1.64,24.44,2.17,35.73,10.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.09,428.72c-.11,0,8.4-32.53,19-72.59s19.32-72.51,19.43-72.48-8.39,32.53-19,72.59S358.21,428.75,358.09,428.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.08,432.33c0,.12-12.65-3.13-28.19-7.25s-28.12-7.55-28.09-7.66,12.66,3.13,28.2,7.25S440.11,432.22,440.08,432.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.72,435.84c0,.11-9.4-2.27-20.93-5.33s-20.86-5.63-20.83-5.74,9.4,2.27,20.94,5.32S431.75,435.72,431.72,435.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,318.09a2.86,2.86,0,0,1-3.84,2l-1.2-.32-.54,2-2-.52,2.05-7.75,3.17.84A2.86,2.86,0,0,1,417,318.09Zm-2-.52a1.1,1.1,0,0,0-.92-1.46l-1.09-.29-.6,2.27,1.09.29A1.1,1.1,0,0,0,415,317.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.35,322.86l-2.93-.78-.94,1.36-2-.53,5.11-6.93,1.93.51,1,8.56-2-.54Zm-.15-1.77-.23-2.71-1.55,2.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.79,324.37l1.07-1.44A4.33,4.33,0,0,0,427,324.3c.81.21,1.19,0,1.29-.34.33-1.22-3.85-1.37-3.09-4.25.37-1.38,1.68-2.24,3.74-1.7a4.92,4.92,0,0,1,2.33,1.34l-1,1.47a4,4,0,0,0-1.76-1.11c-.83-.21-1.2,0-1.31.4-.31,1.19,3.85,1.34,3.1,4.2-.36,1.35-1.68,2.23-3.74,1.69A5.23,5.23,0,0,1,423.79,324.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.2,326.07l1.07-1.45a4.13,4.13,0,0,0,2.08,1.37c.81.22,1.2.05,1.3-.33.32-1.23-3.85-1.37-3.09-4.25.37-1.38,1.67-2.24,3.73-1.7a5,5,0,0,1,2.34,1.34l-1,1.47a3.89,3.89,0,0,0-1.76-1.11c-.82-.22-1.2,0-1.3.4-.32,1.19,3.85,1.34,3.09,4.2-.36,1.35-1.67,2.23-3.73,1.68A5.18,5.18,0,0,1,430.2,326.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.44,325.37a2.86,2.86,0,0,1-3.83,2l-1.21-.32-.54,2-2-.52,2.05-7.74,3.17.84A2.86,2.86,0,0,1,444.44,325.37Zm-2-.53a1.09,1.09,0,0,0-.92-1.46l-1.08-.29-.6,2.27,1.08.29A1.1,1.1,0,0,0,442.46,324.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.87,326.56a4,4,0,1,1,2.78,5.05A4,4,0,0,1,444.87,326.56Zm5.72,1.52a2,2,0,1,0-2.46,1.71A2.06,2.06,0,0,0,450.59,328.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15,331.49l-1.07-.28-.55,2.06-2-.52,2.06-7.75,3.16.84a2.86,2.86,0,0,1,2.32,3.68,2.71,2.71,0,0,1-2,2.09l.85,2.83-2.1-.56Zm1.07-4-1.09-.28-.6,2.26,1.09.29a1.08,1.08,0,0,0,1.51-.8A1.1,1.1,0,0,0,457.22,327.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.87,329l-2.13-.56.46-1.74,6.2,1.65-.46,1.73-2.11-.56-1.6,6-2-.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.86,342.39c0,.14-14-3.38-31.12-7.86s-31-8.23-31-8.37,14,3.38,31.13,7.86S466.9,342.25,466.86,342.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.65,344c0,.14-8.38-1.92-18.65-4.6s-18.56-5-18.52-5.1,8.39,1.92,18.65,4.6S452.69,343.84,452.65,344Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.67,388.15a6.78,6.78,0,0,1-9.38,2.53S457.85,385,463.67,388.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,396.51a5.94,5.94,0,0,1-8.47-.74S454.18,392.2,458,396.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.31,402.16a6.32,6.32,0,0,1-8.47-3.21S448.62,396.62,451.31,402.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.5,386.19a5.94,5.94,0,0,1,.47,8.49S446.78,390.61,450.5,386.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.69,392.47a4.5,4.5,0,0,1-2.85,5.86A4.7,4.7,0,0,1,447.69,392.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.12,380.39a5.38,5.38,0,0,1-6.28,4.46S457.94,379.67,463.12,380.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.8,373.37s3.83,2.95.62,7.5A5.48,5.48,0,0,1,456.8,373.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.29,379.89a6.23,6.23,0,0,1,3.39,8.24S450.13,385.54,452.29,379.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.43,399.41h.31c.2,0,.5,0,.88,0a16.38,16.38,0,0,0,3.19-.45,17.77,17.77,0,0,0,4.44-1.74,19,19,0,0,0,2.37-1.53l.58-.46.3-.24.28-.25.57-.51.54-.55.27-.28.26-.29c.17-.19.34-.38.5-.58l.46-.59.23-.3.21-.3.41-.6.37-.61.18-.3a2.38,2.38,0,0,0,.17-.31c.11-.2.22-.4.32-.6a19.88,19.88,0,0,0,1.65-4.48,20.82,20.82,0,0,0,.47-3.2c0-.38,0-.67,0-.87v-.23a.28.28,0,0,1,0-.08v.31c0,.2,0,.49,0,.88a19.56,19.56,0,0,1-.46,3.2,20,20,0,0,1-1.63,4.5l-.32.6-.17.31-.18.3-.38.61-.41.61-.21.3-.23.3-.46.6-.5.58-.26.29-.27.28-.55.55-.57.51-.28.26-.29.23-.59.46a20.41,20.41,0,0,1-2.38,1.54,18.21,18.21,0,0,1-4.46,1.73,16.94,16.94,0,0,1-3.2.43h-1.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.2,367.35a6.77,6.77,0,0,0,6.89,6.84S391.8,367.52,385.2,367.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,377.41a5.94,5.94,0,0,0,7.72,3.55S391.44,375.57,386,377.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,385.64a6.34,6.34,0,0,0,9,1.41S394.08,382.17,389,385.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.61,372.18a5.92,5.92,0,0,0-4.61,7.13S398.65,377.85,397.61,372.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.94,379a4.5,4.5,0,0,0-.43,6.5A4.69,4.69,0,0,0,396.94,379Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.52,360.88a5.38,5.38,0,0,0,3.25,7S394.38,362.82,389.52,360.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.48,357.92s-4.78.66-4.25,6.2A5.46,5.46,0,0,0,398.48,357.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.18,365.81a6.22,6.22,0,0,0-7,5.48S398.26,371.79,399.18,365.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.55,389.63l-.07,0-.2-.11c-.17-.1-.43-.24-.75-.45a16.09,16.09,0,0,1-2.55-2,17.9,17.9,0,0,1-3-3.71,20.37,20.37,0,0,1-1.3-2.51l-.28-.69-.14-.35-.12-.35-.24-.73c-.06-.25-.13-.5-.2-.75l-.1-.37-.07-.38c0-.25-.11-.5-.15-.75s-.07-.5-.11-.75,0-.25,0-.37l0-.37-.06-.72c0-.24,0-.48,0-.72v-.35c0-.11,0-.23,0-.35s0-.45,0-.68a20.12,20.12,0,0,1,.8-4.71,21.38,21.38,0,0,1,1.16-3l.41-.78.11-.21,0-.07a.28.28,0,0,1,0,.07l-.11.2-.42.77a21.06,21.06,0,0,0-1.19,3,19.58,19.58,0,0,0-.81,4.72l0,.68c0,.12,0,.24,0,.35s0,.24,0,.36,0,.47,0,.71l.06.73,0,.37.06.37c0,.25.07.5.1.75l.15.75c0,.13.05.25.08.38l.1.38c.07.25.13.5.2.75l.24.73.12.36c.05.11.09.23.14.35l.28.69a19.11,19.11,0,0,0,1.31,2.51,17.71,17.71,0,0,0,3,3.71,15.2,15.2,0,0,0,2.57,2c.33.21.59.34.77.44l.2.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 116.93,
    width: 253.54,
    height: 359.86,
    rx: 10.24,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.72,476.8l.79-.05a11.52,11.52,0,0,0,2.28-.45,10.58,10.58,0,0,0,3.35-1.82,10.26,10.26,0,0,0,3.07-4.23,9.83,9.83,0,0,0,.67-3.1c.06-1.12,0-2.31,0-3.55,0-2.48,0-5.2,0-8.14,0-5.89,0-12.69,0-20.34,0-30.6-.05-74.87-.08-129.57,0-27.35,0-57.31,0-89.48q0-24.12,0-49.84,0-12.85,0-26.07,0-6.61,0-13.3a10,10,0,0,0-2.26-6,10.15,10.15,0,0,0-5.52-3.41,14.65,14.65,0,0,0-3.33-.25H138.69a10,10,0,0,0-10,9.5c-.05,5.16,0,10.35,0,15.5v30.71q0,30.5,0,60c0,39.36,0,77.33,0,113.5s0,70.54,0,102.71q0,6,0,12c0,2,0,3.95,0,5.89a10,10,0,0,0,1.82,5.35,10.12,10.12,0,0,0,4.38,3.5,10.68,10.68,0,0,0,2.72.7c.93.08,1.89.06,2.84.06h54.25l129.56.08,35.23.05,9.16,0,3.12,0-3.12,0-9.16,0-35.23,0L194.65,477l-42.94,0H140.4c-1,0-1.9,0-2.88-.06a11.12,11.12,0,0,1-2.83-.73,10.49,10.49,0,0,1-4.55-3.63,10.37,10.37,0,0,1-1.89-5.56c-.05-2,0-3.93,0-5.91v-12c0-32.17,0-66.54,0-102.71s0-74.14,0-113.5V142.18c0-5.16,0-10.31,0-15.52a10.48,10.48,0,0,1,10.49-10H370.61A14.22,14.22,0,0,1,374,117a10.64,10.64,0,0,1,5.77,3.56,10.48,10.48,0,0,1,2.36,6.32q0,6.69,0,13.31v26.07q0,25.7,0,49.84c0,32.17,0,62.13,0,89.48,0,54.7-.06,99-.08,129.57,0,7.65,0,14.45,0,20.34,0,2.94,0,5.66,0,8.14,0,1.25,0,2.43,0,3.56a9.9,9.9,0,0,1-.69,3.12,10.29,10.29,0,0,1-3.11,4.26,10.47,10.47,0,0,1-3.39,1.81,11,11,0,0,1-2.29.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "150.54 468.67 320.17 468.67 361 424.41 361 400.85 150.54 433.73 150.54 468.67"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.17 117.67 324 132.01 324 139.03 318.55 139.03 319.17 117.67"
  }))), /*#__PURE__*/React.createElement("polyline", {
    points: "312.18 461.92 139.73 461.92 139.73 131.35 370.65 131.35 370.65 402.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.66,402.81s0-.43,0-1.27,0-2.1,0-3.76c0-3.31,0-8.23,0-14.63,0-12.81,0-31.57-.06-55.39,0-47.64-.06-115.5-.09-196.41l.22.22-230.93,0,.25-.25v.3c0,127.07,0,243.12-.07,330.27l-.18-.18,126.07.08,34.38.05,8.95,0c2,0,3.05,0,3.05,0l-3.05,0-8.95,0-34.38,0-126.07.08h-.18v-.19c0-87.15,0-203.2-.06-330.27v-.54h.24l230.93,0h.21v.22c0,80.91-.06,148.77-.09,196.41,0,23.82,0,42.58-.06,55.39,0,6.4,0,11.32,0,14.63,0,1.66,0,2.91,0,3.76S370.66,402.81,370.66,402.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.18 461.92 370.65 402.81 312.18 402.81 312.18 461.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.18,461.92c0-2-.09-24.43-.22-59.11v-.22h.22l41.25,0h17.81l-.41.41-41.89,42.15-16.76,16.79L329,444.81l41.52-42.17.18.41H353.43l-41.25,0,.23-.23C312.27,437.49,312.19,460,312.18,461.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,427c0,.13-34.37.24-76.76.24s-76.76-.11-76.76-.24,34.36-.25,76.76-.25S309.29,426.85,309.29,427Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,434.76c0,.13-34.37.24-76.76.24s-76.76-.11-76.76-.24,34.36-.25,76.76-.25S309.29,434.62,309.29,434.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.63,442.52c0,.14-15.64.25-34.93.25s-34.93-.11-34.93-.25,15.63-.24,34.93-.24S225.63,442.39,225.63,442.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.65,108H312.84a6.33,6.33,0,0,1,6.33,6.33v27.56a0,0,0,0,1,0,0H202.33a0,0,0,0,1,0,0V114.3A6.33,6.33,0,0,1,208.65,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.62 95.22 245.88 95.22 249.35 120.72 271.76 120.72 275.62 95.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.66,108c0,.14-22.79.24-50.91.24s-50.92-.1-50.92-.24,22.8-.25,50.92-.25S311.66,107.83,311.66,108Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.94,136.39c-.13,0-.24-4.79-.24-10.7s.11-10.71.24-10.71.25,4.79.25,10.71S205.08,136.39,204.94,136.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.39,133.86a94.17,94.17,0,0,1-.25-9.72,94,94,0,0,1,.25-9.72c.13,0,.24,4.35.24,9.72S315.52,133.86,315.39,133.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.75,138.36c0,.14-23.4.25-52.26.25s-52.27-.11-52.27-.25,23.4-.24,52.27-.24S309.75,138.23,309.75,138.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.33,
    y: 161.75,
    width: 192.49,
    height: 45.05,
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,178.1h2.26v15.82H188Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.59,178.1v15.82h-1.85l-9.49-11.79v11.79H195V178.1h1.85l9.5,11.8V178.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.51,193.55a7.29,7.29,0,0,1-2.62-1.43l.84-1.77a6.83,6.83,0,0,0,2.32,1.33,8.47,8.47,0,0,0,2.9.5,5.29,5.29,0,0,0,2.94-.66,2.06,2.06,0,0,0,1-1.78,1.76,1.76,0,0,0-.53-1.32,3.49,3.49,0,0,0-1.31-.78c-.52-.18-1.25-.38-2.2-.61a21.75,21.75,0,0,1-2.89-.86,4.64,4.64,0,0,1-1.87-1.32,3.53,3.53,0,0,1-.78-2.41,4,4,0,0,1,.67-2.28,4.53,4.53,0,0,1,2-1.63,8.29,8.29,0,0,1,3.37-.61,10.65,10.65,0,0,1,2.75.36,7.56,7.56,0,0,1,2.33,1l-.75,1.81a8.27,8.27,0,0,0-2.12-1,7.84,7.84,0,0,0-2.21-.33,4.86,4.86,0,0,0-2.89.71,2.13,2.13,0,0,0-1,1.8,1.71,1.71,0,0,0,.55,1.33,3.93,3.93,0,0,0,1.34.79c.54.18,1.26.38,2.18.6a22.12,22.12,0,0,1,2.87.85,4.92,4.92,0,0,1,1.87,1.31,3.46,3.46,0,0,1,.78,2.38,4.06,4.06,0,0,1-.68,2.27,4.52,4.52,0,0,1-2.06,1.63,8.5,8.5,0,0,1-3.39.6A10.74,10.74,0,0,1,214.51,193.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,192.3a7.18,7.18,0,0,1-1.76-5.2v-9h2.26V187q0,5.09,4.45,5.08a4.25,4.25,0,0,0,3.32-1.25,5.5,5.5,0,0,0,1.16-3.83V178.1h2.19v9a7.17,7.17,0,0,1-1.76,5.21,7.64,7.64,0,0,1-9.86,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.83,193.92l-3.41-4.85c-.43,0-.76,0-1,0h-3.91v4.81h-2.26V178.1h6.17a7.34,7.34,0,0,1,4.84,1.47,5,5,0,0,1,1.76,4.05,5.32,5.32,0,0,1-.9,3.12,5.06,5.06,0,0,1-2.58,1.87l3.75,5.31Zm-1.2-7.66a3.19,3.19,0,0,0,1.13-2.64,3.16,3.16,0,0,0-1.13-2.63,5.08,5.08,0,0,0-3.27-.92h-3.85v7.12h3.85A5,5,0,0,0,254.63,186.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.76,190h-8.4l-1.75,3.95h-2.32l7.16-15.82h2.24l7.19,15.82H273.5Zm-.79-1.81-3.41-7.75-3.41,7.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.83,178.1v15.82H290l-9.49-11.79v11.79h-2.26V178.1h1.85l9.49,11.8V178.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.37,193.05a7.79,7.79,0,0,1-3-2.89,8.49,8.49,0,0,1,0-8.29,7.84,7.84,0,0,1,3-2.9,8.79,8.79,0,0,1,4.29-1.05,9,9,0,0,1,3.39.62,7,7,0,0,1,2.63,1.85l-1.47,1.42a5.91,5.91,0,0,0-4.46-1.88,6.42,6.42,0,0,0-3.18.8,5.7,5.7,0,0,0-2.23,2.18,6.43,6.43,0,0,0,0,6.21,5.7,5.7,0,0,0,2.23,2.18,6.41,6.41,0,0,0,3.18.79,5.93,5.93,0,0,0,4.46-1.89l1.47,1.42a7.14,7.14,0,0,1-2.64,1.85,8.91,8.91,0,0,1-3.4.64A8.63,8.63,0,0,1,299.37,193.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.4,192v2H312.92V178.1h11.16v2h-8.9v4.86h7.93v1.92h-7.93V192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.89,
    y: 235.24,
    width: 127.53,
    height: 7.84,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.89,
    y: 251.25,
    width: 57.86,
    height: 7.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.43,
    y: 231.89,
    width: 29.49,
    height: 29.49,
    rx: 3.86,
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.75 253.66 177.49 247.27 179.71 244.39 185.25 248.67 193.13 239.61 195.88 242 185.75 253.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.89,
    y: 283.77,
    width: 127.53,
    height: 7.84,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.89,
    y: 299.79,
    width: 57.86,
    height: 7.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.43,
    y: 280.42,
    width: 29.49,
    height: 29.49,
    rx: 3.86,
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.75 302.19 177.49 295.81 179.71 292.93 185.25 297.21 193.13 288.14 195.88 290.53 185.75 302.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.89,
    y: 335.78,
    width: 127.53,
    height: 7.84,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.89,
    y: 351.79,
    width: 57.86,
    height: 7.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.89,
    y: 383.85,
    width: 127.53,
    height: 7.84,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.89,
    y: 399.87,
    width: 57.86,
    height: 7.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.43,
    y: 332.43,
    width: 29.49,
    height: 29.49,
    rx: 3.86,
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.75 354.19 177.49 347.81 179.71 344.93 185.25 349.21 193.13 340.15 195.88 342.54 185.75 354.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.05,411.86H175.29a4.36,4.36,0,0,1-4.36-4.36V385.74a4.37,4.37,0,0,1,4.36-4.37h21.76a4.37,4.37,0,0,1,4.36,4.37V407.5A4.37,4.37,0,0,1,197.05,411.86Zm-21.76-29.49a3.36,3.36,0,0,0-3.36,3.37V407.5a3.36,3.36,0,0,0,3.36,3.36h21.76a3.37,3.37,0,0,0,3.36-3.36V385.74a3.37,3.37,0,0,0-3.36-3.37Z",
    style: {
      fill: "#37474F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Airplane--inject-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "60.73 102.78 61.4 70.7 72.34 76.32 76.97 95.62 60.73 102.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.24 117.44 84.68 123.18 88.99 122.68 81.46 116.74 74.04 115.26 73.24 117.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.05 98.14 193.99 131.49 145.67 100.38 151.05 98.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.23,107.14c.65.33,62.92,25.11,62.92,25.11l6.84-.76L146.72,97.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.37,112.73l-5.14,2.1a1.86,1.86,0,0,1-2.43-1h0a1.85,1.85,0,0,1,1-2.43l5.14-2.1a1.87,1.87,0,0,1,2.44,1h0A1.86,1.86,0,0,1,142.37,112.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.17,126.94,167,129a1.86,1.86,0,0,1-2.43-1h0a1.87,1.87,0,0,1,1-2.43l5.15-2.1a1.86,1.86,0,0,1,2.43,1h0A1.87,1.87,0,0,1,172.17,126.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.83,102.11s-18.73,2.58-16.11,12.41,21.11-.52,21.11-.52,2.74-1.58,1.69-6.82S163.83,102.11,163.83,102.11Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.94,106.86a6.47,6.47,0,0,0-2-3.24,3,3,0,0,0-3.57-.14l-.52.33a5.28,5.28,0,0,0-1.07,5.48l-.19-.59a8.12,8.12,0,0,0,3.14,5,3,3,0,0,0,1.49.65,2.52,2.52,0,0,0,1.86-.78,4.89,4.89,0,0,0,1.39-3.21A9.24,9.24,0,0,0,168.94,106.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.87,107.16s-7.65,7.65,6.9,9.51,39.75.94,68.12-8.77,53.61-23.31,58-26.87c3.28-2.64,8.54-7.16,6.66-13.65a11.09,11.09,0,0,0-6.89-7.16A32.77,32.77,0,0,0,164.14,59C151.45,62.37,50.87,107.16,50.87,107.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.87,107.16l.76-.32,2.22-1,8.51-3.73L93.67,88.48c13.23-5.74,29-12.58,46.58-19.94,4.41-1.82,8.92-3.7,13.56-5.53,2.31-.94,4.68-1.79,7.06-2.69,1.21-.38,2.41-.81,3.64-1.16a29.93,29.93,0,0,1,3.78-.69,33.49,33.49,0,0,1,15.44,2,11.15,11.15,0,0,1,5.86,5.09,9.33,9.33,0,0,1,.53,7.73,16.66,16.66,0,0,1-4.89,6.34,39.14,39.14,0,0,1-6.64,4.53c-4.64,2.68-9.33,5.1-14,7.38-9.31,4.56-18.51,8.54-27.39,12a223,223,0,0,1-25.7,8.42,174.77,174.77,0,0,1-23.15,4.3,144.05,144.05,0,0,1-19.41,1c-2.86,0-5.52-.19-8-.38a43.88,43.88,0,0,1-6.62-1,8.94,8.94,0,0,1-4.64-2.41,3.43,3.43,0,0,1-.8-1.92,4.42,4.42,0,0,1,.26-1.72,7.88,7.88,0,0,1,1.16-2.09,8,8,0,0,1,.52-.64,4.77,4.77,0,0,0-.55.61,7.28,7.28,0,0,0-1.22,2.09,4.55,4.55,0,0,0-.29,1.76,3.54,3.54,0,0,0,.81,2,9,9,0,0,0,4.7,2.5,43,43,0,0,0,6.65,1c2.44.21,5.11.39,8,.43a143.68,143.68,0,0,0,19.44-1,173.79,173.79,0,0,0,23.22-4.25,220.26,220.26,0,0,0,25.75-8.4c8.91-3.44,18.11-7.41,27.45-12,4.66-2.29,9.36-4.71,14-7.39A39.27,39.27,0,0,0,185.53,80a17,17,0,0,0,5-6.52,9.81,9.81,0,0,0-.56-8.12,11.49,11.49,0,0,0-6.11-5.3,33.87,33.87,0,0,0-15.66-2,28.73,28.73,0,0,0-3.83.71c-1.25.35-2.46.78-3.68,1.17-2.38.91-4.76,1.76-7.07,2.71-4.65,1.83-9.16,3.71-13.56,5.54-17.59,7.38-33.34,14.25-46.55,20L62.29,102l-8.48,3.8-2.2,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.73 99.12 74.73 102.11 95.31 93.25 92.15 91.53 74.73 99.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.34 97.44 76.34 102.54 78.21 101.72 78.21 96.5 76.34 97.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.29 95.28 80.29 100.38 82.16 99.56 82.16 94.34 80.29 95.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.24 93.77 84.24 98.86 86.12 98.05 86.12 92.83 84.24 93.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.02 90.63 92.02 95.72 93.9 94.91 93.9 89.69 92.02 90.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.91 47.86 100.08 95.84 119.91 86.33 22.5 47.01 11.91 47.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "116.19 78.53 22.5 47.01 119.91 86.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.91,86.33l-.48-.22-1.42-.6-5.49-2.26L92.28,75,25.47,48l-2.89-1.17-.16.44L88.81,69.49c8.45,2.82,15.29,5.09,20,6.66l5.44,1.79,1.42.45.49.14s-.16-.07-.48-.18l-1.4-.5L108.9,76l-20-6.8L22.57,46.79l-.16.44,2.88,1.16L92.16,75.31l20.29,8.11L118,85.6l1.45.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.38,70.68,53.91,74a1.87,1.87,0,0,1-2.61-.4h0A1.87,1.87,0,0,1,51.69,71l4.47-3.3a1.87,1.87,0,0,1,2.61.4h0A1.87,1.87,0,0,1,58.38,70.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,93.78c.3.2,28,14.47,28,14.47l6.06-3.39L29.49,93.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.99 93.38 31.9 93.38 59.3 103.42 56.05 104.86 29.99 93.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.33 79.78 121.91 81.73 163.1 64.13 162.63 61.23 119.33 79.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.62 77.48 121.62 82.57 123.5 81.76 123.5 76.54 121.62 77.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.83 75.57 125.83 80.67 127.7 79.85 127.7 74.64 125.83 75.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.03 73.67 130.03 78.76 131.9 77.95 131.9 72.73 130.03 73.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.23 71.76 134.23 76.86 136.11 76.04 136.11 70.82 134.23 71.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.44 69.86 138.44 74.95 140.31 74.14 140.31 68.92 138.44 69.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.64 67.95 142.64 73.04 144.52 72.23 144.52 67.01 142.64 67.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.85 66.38 146.85 71.48 148.72 70.66 148.72 65.45 146.85 66.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.06 92.19 88.06 97.29 89.93 96.47 89.93 91.26 88.06 92.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.05 64.59 151.05 69.69 152.93 68.87 152.93 63.66 151.05 64.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.31 62.91 155.31 68 157.19 67.19 157.19 61.97 155.31 62.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.57 61.23 159.57 66.32 161.45 65.51 161.45 60.29 159.57 61.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.36,61.61s7-2.08,11.33-1.39a17.18,17.18,0,0,0-4-1.23s-2.65-1-7.94.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.99 122.68 83.74 116.9 81.23 117.1 88.99 122.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.21,117.12l0,0,2.58-.2h0L89,122.67l.14.16Zm.08,0,7.54,5.42-5.1-5.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.81,80.52l-4.47,3.3a1.88,1.88,0,0,1-2.61-.39h0a1.87,1.87,0,0,1,.4-2.61l4.47-3.3a1.86,1.86,0,0,1,2.61.39h0A1.87,1.87,0,0,1,76.81,80.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.86,60.19l-4.48,3.3a1.87,1.87,0,0,1-2.61-.39h0a1.87,1.87,0,0,1,.4-2.61l4.47-3.3a1.87,1.87,0,0,1,2.61.39h0A1.88,1.88,0,0,1,38.86,60.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.19,68.65s-18,5.7-13.8,14.95,20.72-4.07,20.72-4.07,2.43-2,.52-7S93.19,68.65,93.19,68.65Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,72.48a6.42,6.42,0,0,0-2.51-2.86,2.93,2.93,0,0,0-3.54.47l-.46.41a5.29,5.29,0,0,0-.13,5.58l-.29-.55A8.17,8.17,0,0,0,96,80a3,3,0,0,0,1.58.39,2.52,2.52,0,0,0,1.69-1.08,4.89,4.89,0,0,0,.84-3.41A9.26,9.26,0,0,0,99,72.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.66,72.66c-2.55-.72-4.83.62-6.94,1.89-33.1,20-70.16,35.89-108.77,35.8a2.17,2.17,0,0,0-2,1.35h0a2.17,2.17,0,0,0,1.92,3A182,182,0,0,0,177.77,79.17c1.24-.93,2.58-2,2.37-3.77A3.32,3.32,0,0,0,177.66,72.66Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6,313.25l8.15,1.81a28.76,28.76,0,0,1,3.11,10.15c.48,5.43-2.63,44.79-2.63,44.79l-26.11-.86-.79-1.82a5.66,5.66,0,0,1-.47-2.88c.66-6.47,1.82-28.92,8.16-42C52.05,316.24,59.6,313.25,59.6,313.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.26,239.33l-6.41,79.09,9.63,1.14c.08,0,8-83,8-83S68.43,235.4,65.26,239.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.27,311.37a8.38,8.38,0,0,1-.13,1.47c-.13,1-.31,2.38-.53,4l-.39,2.75a25,25,0,0,1-.56,3.15A7,7,0,0,1,66,325.94a4.29,4.29,0,0,1-3.68,1.21,5,5,0,0,1-3.29-2.06A6.58,6.58,0,0,1,58,321.64a13.8,13.8,0,0,1,.28-3.22l.48-2.73.72-3.95a9.15,9.15,0,0,1,.33-1.44,7.25,7.25,0,0,1-.13,1.47l-.56,4c-.13.85-.26,1.77-.41,2.75a13.18,13.18,0,0,0-.23,3.12,6.27,6.27,0,0,0,1,3.18,4.5,4.5,0,0,0,3,1.84,3.82,3.82,0,0,0,3.25-1.06,6.61,6.61,0,0,0,1.53-3c.29-1.06.43-2.13.6-3.11l.45-2.73.69-4A7.63,7.63,0,0,1,69.27,311.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.39,321.3a1.74,1.74,0,1,1-1.74-1.74A1.74,1.74,0,0,1,64.39,321.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.85,317.32a2.34,2.34,0,0,1-.12.54c-.12.4-.26.9-.44,1.51-.4,1.38-.95,3.26-1.62,5.54-1.34,4.69-3.06,11.21-4.6,18.49s-2.59,13.94-3.25,18.77c-.31,2.37-.57,4.3-.76,5.73q-.12.94-.21,1.56a3.18,3.18,0,0,1-.1.54,1.93,1.93,0,0,1,0-.55c0-.42.07-.94.11-1.57.11-1.36.3-3.33.59-5.75.57-4.86,1.58-11.54,3.11-18.84s3.32-13.81,4.76-18.48c.71-2.34,1.32-4.22,1.78-5.5.21-.6.39-1.09.53-1.48A2.08,2.08,0,0,1,58.85,317.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.44,213.28a8.14,8.14,0,0,0,1.66-2.1,6.34,6.34,0,0,0,0-3A8.08,8.08,0,0,1,69.66,201c2-1.67,5.35-1.81,7.22.05L92.27,211a15.22,15.22,0,0,1,3.11,11.57,7.17,7.17,0,0,1-2.1,4.47,3.59,3.59,0,0,1-4.61.23,6.7,6.7,0,0,1-11.93,3.18,5.18,5.18,0,0,1-9.15-2.81c-.12-1.2.19-2.44-.17-3.59-.41-1.34-1.62-2.26-2.4-3.42A6.22,6.22,0,0,1,65.44,213.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,206.29a5,5,0,0,1,.23-6.5,3.35,3.35,0,0,1,.21-4.13,10,10,0,0,1,3.7-2.57,7,7,0,0,1,8-5.27c1.72-2.65,5.56-3.19,8.68-2.42a8.38,8.38,0,0,0,2.31.41,14.2,14.2,0,0,0,1.71-.29,7.53,7.53,0,0,1,7.65,4.34,5.39,5.39,0,0,0,.72,1.31,7.73,7.73,0,0,0,1.59,1.16,4.89,4.89,0,0,1,2.06,3.55c.09,1.19-.25,2.47.3,3.53a17.81,17.81,0,0,1,1,1.52c.64,1.61-1.16,3.35-.75,5,.08.34.25.66.36,1a2.93,2.93,0,0,1-.11,2.12,4.41,4.41,0,0,0-.63,1.55,5,5,0,0,0,.3,1.23c.25,1-1.85,5-2.73,5.57l-26.83,1.16a5,5,0,0,1-4-4.08,1.67,1.67,0,0,0-.29-1,2.11,2.11,0,0,0-.74-.44c-1.76-.84-2.06-3.15-1.94-5.06a2.38,2.38,0,0,0-.05-.8A2.83,2.83,0,0,0,75.71,206.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.71,234.89l.08,0A0,0,0,0,0,84.71,234.89Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.31,203c-.47-5.24-6.06-9.9-7.55-10.19a11.09,11.09,0,0,0-6.38-1.08,18.25,18.25,0,0,0-6.8,1.85,14,14,0,0,0-7.18,12.49l1.39,30.45c3.12,3.44,11.68,4.75,11.68,4.75s5.45,1.24,7-.94c0,0-.68-9.9-.68-9.89a11.46,11.46,0,0,0,8.84-10.1C112.24,216,111.84,208.82,111.31,203Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.87,210.12a1.14,1.14,0,0,1-1.09,1.16,1.09,1.09,0,0,1-1.21-1,1.14,1.14,0,0,1,1.08-1.16A1.1,1.1,0,0,1,108.87,210.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34,206.4c-.14.15-1-.45-2.27-.42s-2.13.66-2.27.51.07-.33.46-.62a3.16,3.16,0,0,1,1.81-.59,3,3,0,0,1,1.81.52C109.27,206.07,109.41,206.34,109.34,206.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.33,216.12a8,8,0,0,1,2-.4c.32,0,.62-.11.66-.32a1.53,1.53,0,0,0-.23-.91c-.32-.74-.65-1.52-1-2.33a38.89,38.89,0,0,1-2.26-6.09,39.18,39.18,0,0,1,2.75,5.9c.34.82.65,1.6,1,2.34a1.75,1.75,0,0,1,.19,1.21.77.77,0,0,1-.51.46,1.89,1.89,0,0,1-.53.09A7.89,7.89,0,0,1,102.33,216.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.83,230.4a23.38,23.38,0,0,1-12.14-2.84s3.06,6.22,12,5.18Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,201.59c-.2.3-1.15.13-2.26.24s-2,.43-2.27.17,0-.42.38-.73a3.44,3.44,0,0,1,1.78-.66,3.32,3.32,0,0,1,1.87.34C108.33,201.18,108.49,201.45,108.4,201.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.32,211A1.14,1.14,0,0,0,96.5,212a1.08,1.08,0,0,0,1.12-1.08,1.13,1.13,0,0,0-1.18-1.06A1.09,1.09,0,0,0,95.32,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,207.28c.15.14,1-.54,2.22-.61s2.18.47,2.31.32-.1-.33-.51-.58a3.2,3.2,0,0,0-1.86-.44,3.15,3.15,0,0,0-1.76.67C92.44,207,92.33,207.22,92.4,207.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.23,202.55c.26.26,1.2-.09,2.34-.17s2.13.06,2.34-.24c.09-.15-.08-.41-.52-.65a3.66,3.66,0,0,0-1.94-.33,3.6,3.6,0,0,0-1.83.66C92.23,202.13,92.12,202.42,92.23,202.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.06,214.33c0-.65-.83-2.17-1.49-2.26-1.77-.22-4.95,0-4.87,4.36.11,6,6.23,4.63,6.24,4.46S85.12,216.58,85.06,214.33Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.21,218.74s-.1.07-.28.16a1.12,1.12,0,0,1-.8,0,2.57,2.57,0,0,1-1.26-2.29,3.32,3.32,0,0,1,.27-1.5,1.2,1.2,0,0,1,.79-.81.55.55,0,0,1,.63.27c.09.17,0,.29.08.3s.13-.1.08-.35a.65.65,0,0,0-.25-.37.82.82,0,0,0-.59-.14,1.49,1.49,0,0,0-1.1,1,3.47,3.47,0,0,0-.34,1.67,2.71,2.71,0,0,0,1.61,2.55,1.15,1.15,0,0,0,1-.18C83.2,218.88,83.23,218.75,83.21,218.74Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.67,203a3.47,3.47,0,0,1-2-3.15c-.81.26-1.67-.75-2.17-1.43s-1.09-1-1.07-1.85a.86.86,0,0,0-.08-.48,1,1,0,0,0-.67-.37,4,4,0,0,1-2.77-2.71,9,9,0,0,1-4.18.78,3.36,3.36,0,0,1-5.61-.1,3,3,0,0,1-2,1.47,8.58,8.58,0,0,1-2.53.2,3.41,3.41,0,0,1-2.21,3.94c-.22.07-.47.14-.56.34s0,.45.11.66a2.68,2.68,0,0,1-1.76,3.48,2,2,0,0,1-.11,3.15c-.21.14-.5.3-.46.56a.57.57,0,0,0,.14.25,3.92,3.92,0,0,1,1,1.95,1.45,1.45,0,0,1-1.17,1.62,2,2,0,0,1,.81,1.29c0,.52-.51,1.06-1,.89-.21-.08-3.27-.59-3.41-.76-1.79-2.25.32-4.84.42-7.69A18.14,18.14,0,0,1,83.85,197,13.42,13.42,0,0,1,86,194a18.48,18.48,0,0,1,3.3-2.5,16.77,16.77,0,0,1,4.85-2.4c3.28-.84,6.74.24,9.86,1.56a14.28,14.28,0,0,1,3.37,1.83,12.69,12.69,0,0,1,2.89,3.5,15.54,15.54,0,0,1,2.37,6.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.82,200.93a2.32,2.32,0,0,0-.35-.64c-.13-.19-.32-.42-.5-.71a2.7,2.7,0,0,1-.38-1.11,9,9,0,0,1,0-1.48,6.38,6.38,0,0,0-.1-1.77,4.78,4.78,0,0,0-.85-1.86,5,5,0,0,0-.78-.82,6.83,6.83,0,0,0-1-.68,3.66,3.66,0,0,1-1-.76,4.73,4.73,0,0,1-.61-1.11,8,8,0,0,0-1.55-2.27,8.22,8.22,0,0,0-2.42-1.72,7.9,7.9,0,0,0-1.49-.5,6.61,6.61,0,0,0-1.61-.13,7.58,7.58,0,0,0-.82.08l-.81.17a4.12,4.12,0,0,1-1.64,0c-.55-.09-1.09-.27-1.66-.39a11.24,11.24,0,0,0-1.74-.26,12.07,12.07,0,0,0-1.8,0,10.06,10.06,0,0,0-1.78.37,6.05,6.05,0,0,0-3,2.07l-.22.3.1,0a7,7,0,0,0-5.24,1.17,6.64,6.64,0,0,0-2.84,4.17l0-.07a22.59,22.59,0,0,0-2.12,1.16A6.63,6.63,0,0,0,76,195.75a4,4,0,0,0-.74,2.08,2.79,2.79,0,0,0,.64,2v-.1a4.94,4.94,0,0,0-1.33,3.11,5,5,0,0,0,.72,2.95,6.13,6.13,0,0,0,.42.58,5.27,5.27,0,0,1,.44.52,1.27,1.27,0,0,1,.23.58,3.21,3.21,0,0,1,0,.62,9.59,9.59,0,0,0,.13,2.26,4.66,4.66,0,0,0,.65,1.71,2.92,2.92,0,0,0,1,.95c.32.19.6.26.76.37a1.74,1.74,0,0,1,.22.17.78.78,0,0,0-.21-.19c-.16-.12-.44-.19-.75-.39a3,3,0,0,1-.94-.94,4.69,4.69,0,0,1-.62-1.69,9.06,9.06,0,0,1-.11-2.25,3.31,3.31,0,0,0,0-.63,1.29,1.29,0,0,0-.25-.63c-.13-.19-.29-.36-.44-.54a3.88,3.88,0,0,1-.4-.57,4.79,4.79,0,0,1-.69-2.88,4.71,4.71,0,0,1,1.3-3l0-.05,0,0a2.68,2.68,0,0,1-.6-1.9,3.83,3.83,0,0,1,.72-2,6.29,6.29,0,0,1,1.67-1.53,21,21,0,0,1,2.1-1.14l0,0v0a6.47,6.47,0,0,1,2.78-4.05,6.83,6.83,0,0,1,5.09-1.15h.06l0,0,.21-.29a5.83,5.83,0,0,1,2.94-2,9.44,9.44,0,0,1,1.74-.36,11.63,11.63,0,0,1,1.77,0,9.79,9.79,0,0,1,1.71.25c.56.12,1.11.3,1.67.39a4.15,4.15,0,0,0,.86.06,4.59,4.59,0,0,0,.84-.11c.28-.05.54-.12.81-.16a7.25,7.25,0,0,1,.8-.09,6.85,6.85,0,0,1,1.57.13,7.07,7.07,0,0,1,1.45.49,7.75,7.75,0,0,1,2.38,1.68,7.61,7.61,0,0,1,1.53,2.22,5.08,5.08,0,0,0,.63,1.14,3.87,3.87,0,0,0,1,.78,6.88,6.88,0,0,1,1,.66,4.09,4.09,0,0,1,.76.8,4.64,4.64,0,0,1,.85,1.82,6.16,6.16,0,0,1,.11,1.74,9,9,0,0,0,0,1.49,2.8,2.8,0,0,0,.4,1.13c.19.29.38.51.52.7a3.45,3.45,0,0,1,.29.45A1.32,1.32,0,0,0,113.82,200.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,186.44s.16-.1.45-.25a4.12,4.12,0,0,1,1.32-.41,3.86,3.86,0,0,1,2,.23,3.93,3.93,0,0,1,1.88,1.57,2.94,2.94,0,0,1,.32.67.72.72,0,0,1,0,.63l-.14.2.24-.07a2.55,2.55,0,0,1,1.9.17,2.36,2.36,0,0,1,1.07,1.08,2.51,2.51,0,0,1,.27,1c0,.24,0,.37,0,.37s0,0,0-.09a1.8,1.8,0,0,0,0-.28,2.4,2.4,0,0,0-.22-1A2.54,2.54,0,0,0,98.7,189a2.74,2.74,0,0,0-2-.2l.1.13a.89.89,0,0,0,.06-.78,3.85,3.85,0,0,0-.34-.71,4.13,4.13,0,0,0-2-1.62,4,4,0,0,0-2.11-.21,3.92,3.92,0,0,0-1.34.48,2.15,2.15,0,0,0-.31.22C90.69,186.4,90.65,186.43,90.66,186.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.84,199.18a.45.45,0,0,0,0,.11.77.77,0,0,0,.15.28,1.6,1.6,0,0,0,1,.62,3.14,3.14,0,0,0,1.74-.24,9.23,9.23,0,0,0,1-.39,1.72,1.72,0,0,0,.82-.78l0-.09-.15,0a6.92,6.92,0,0,0,1.85,1,3.36,3.36,0,0,0,1.72.13,2.44,2.44,0,0,0,1.05-.5,1.32,1.32,0,0,0,.21-.23l.06-.09s-.11.1-.32.26a2.38,2.38,0,0,1-1,.43,3.13,3.13,0,0,1-1.65-.16,7.18,7.18,0,0,1-1.79-1l-.1-.07,0,.11,0,.09a1.49,1.49,0,0,1-.74.68,9.3,9.3,0,0,1-.93.4,3.2,3.2,0,0,1-1.66.26,1.6,1.6,0,0,1-1-.53A2.93,2.93,0,0,1,77.84,199.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,219.06a2.1,2.1,0,0,0-1.85-.83,1.91,1.91,0,0,0-1.34.67,1.22,1.22,0,0,0-.13,1.38,1.4,1.4,0,0,0,1.51.43,4.62,4.62,0,0,0,1.51-.85,1.33,1.33,0,0,0,.34-.33.4.4,0,0,0,0-.43",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.09,217c.19,0,.16,1.25,1.21,2.17s2.4.82,2.4,1-.3.24-.87.23a3.08,3.08,0,0,1-2-.76,2.72,2.72,0,0,1-.93-1.82C97.86,217.29,98,217,98.09,217Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,308.46c.47.58,9.68,15,10.15,14.78s7.43-5.63,7.43-5.63l-7.55-17.28Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.69,451.34,99,467.85s16.87,5.74,16.94,8.9h-33l-.38-26.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.85,466a1.35,1.35,0,0,0-1,1.5,1.3,1.3,0,0,0,1.48,1,1.42,1.42,0,0,0,1-1.6,1.35,1.35,0,0,0-1.65-.87",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.91,476.74l.08-2.67,31.91,1.12a2.27,2.27,0,0,1,1.21,1.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.55,467.71c0,.16-.82.2-1.64.69s-1.26,1.15-1.4,1.08.13-1,1.12-1.57S99.59,467.56,99.55,467.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,469.27c0,.16-.67.4-1.25,1.06s-.76,1.38-.92,1.37-.22-.93.5-1.74S103,469.11,103,469.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.76,473.49c-.14,0-.34-.79.11-1.66s1.21-1.19,1.28-1.05-.42.59-.78,1.31S104.92,473.48,104.76,473.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,463.8c-.07.15-.8-.1-1.72-.07s-1.63.28-1.71.14.63-.69,1.7-.71S99.49,463.68,99.4,463.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "99.28 460.48 99.17 463.31 82.72 463.38 82.69 460.01 99.28 460.48"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M70.43,239.32,84.81,235l18,1.36s14.21,6.79,14,7-22.57,19.11-22.57,19.11Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.53,299.68s-12.31,22.37-12.75,37.19,12.84,47.83,12,59.2c-1.3,17.52,11.54,70.1,11.54,70.1l19.16-1.55-7.19-67.3-.87-52.91,4.93-42.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.46,442.62l-13.34,11.1s7.21,17.09,4.93,19.4l-22.38-25.5,20.11-18.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.58,444.6a1.31,1.31,0,0,0-1.78.31,1.4,1.4,0,0,0,.27,1.85,1.38,1.38,0,0,0,1.88-.34,1.45,1.45,0,0,0-.49-1.89",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.67,447.62l2-1.83L83.49,471.2a2.51,2.51,0,0,1-.5,2.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,454c-.12.1-.7-.49-1.61-.77s-1.7-.16-1.75-.32.82-.6,1.91-.24S78.73,454,78.59,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.75,457.78c-.09.13-.75-.24-1.63-.21s-1.52.39-1.62.26S77,457,78.11,457,79.87,457.67,79.75,457.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.88,462.17c-.12-.09.34-.82,1.29-1.09s1.69.09,1.63.24-.72.09-1.48.33S78,462.29,77.88,462.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.37,451.15c-.16.05-.47-.69-1.11-1.38s-1.32-1-1.27-1.21.93,0,1.68.81S81.51,451.13,81.37,451.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,448.86c0,.05-.54-.39-1.07-1.32a8.56,8.56,0,0,1-.72-1.75,7.12,7.12,0,0,1-.23-1.1,2,2,0,0,1,0-.66.71.71,0,0,1,.6-.64.84.84,0,0,1,.74.31,2.11,2.11,0,0,1,.34.55,6.91,6.91,0,0,1,.4,1.06,6.45,6.45,0,0,1,.23,1.9,2.92,2.92,0,0,1-.39,1.69c-.09,0,0-.66,0-1.68a7.33,7.33,0,0,0-.32-1.75,8.4,8.4,0,0,0-.4-1c-.16-.34-.35-.58-.52-.55s-.09,0-.12.16a2,2,0,0,0,0,.48,10.15,10.15,0,0,0,.19,1,10.72,10.72,0,0,0,.57,1.69A12.15,12.15,0,0,1,84,448.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.71,448.85c-.06,0,.17-.68.93-1.43a5.36,5.36,0,0,1,1.52-1.06,6.35,6.35,0,0,1,1-.35,1.34,1.34,0,0,1,1.32.28.85.85,0,0,1,.1.86,2.37,2.37,0,0,1-.35.55,4,4,0,0,1-.85.76,3.56,3.56,0,0,1-1.76.6,2.11,2.11,0,0,1-1.62-.38,15.65,15.65,0,0,0,1.57,0,3.8,3.8,0,0,0,1.53-.64,3.74,3.74,0,0,0,.7-.68c.24-.28.37-.58.26-.66a.94.94,0,0,0-.79-.09,6.23,6.23,0,0,0-1,.28,6.06,6.06,0,0,0-1.46.87C84.13,448.36,83.78,448.91,83.71,448.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.33,302.61l1,9.05c6.89,16.21,14.88,58.23,16.49,70.21,1.69,12.56.89,25-3,29.55s-42,40-42,40L72.61,435.74l31.9-35.14s-3-16.07-7-25.45-8.76-31.81-8.76-31.81l1-42.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,422.12a1.21,1.21,0,0,1-.14.16l-.45.44-1.74,1.68-6.57,6.2L85,451.61l-.21.2-.18-.26c-2.23-3.09-4.78-6.32-7.3-9.63l-4.87-6.31-.13-.17.14-.16,22.79-24.77L102,403.2c.79-.82,1.4-1.48,1.85-1.95l.49-.5q.17-.17.18-.15l-.15.19-.45.53-1.78,2-6.67,7.41L72.8,435.63l0-.33,4.87,6.3c2.54,3.33,5,6.49,7.33,9.7l-.4-.06,22.64-20.88,6.67-6.09,1.8-1.61c.19-.17.35-.31.48-.41S116.37,422.11,116.38,422.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.92,
    y: 334.96,
    width: 2.85,
    height: 65.89,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.23,
    y: 337.34,
    width: 2.85,
    height: 65.89,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.49,340.86h-4.28v-6.38a.36.36,0,0,0-.34-.38H145.14a.37.37,0,0,0-.35.38v5.31h-4.28v-5.31a4.65,4.65,0,0,1,4.63-4.66h18.73a4.64,4.64,0,0,1,4.62,4.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.08,472.56a4.44,4.44,0,1,1-4.44-4.44A4.43,4.43,0,0,1,139.08,472.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.35,472.56a4.44,4.44,0,1,1-4.44-4.44A4.43,4.43,0,0,1,177.35,472.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,439.18h0V406.55h0a3.41,3.41,0,0,1,3.41,3.41v25.81A3.41,3.41,0,0,1,184,439.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.02,
    y: 379.27,
    width: 64.5,
    height: 91.12,
    rx: 13.97,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,390.68c0,.11-14.44.19-32.26.19s-32.26-.08-32.26-.19,14.44-.18,32.26-.18S185.46,390.58,185.46,390.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,400.31c0,.1-14.44.18-32.26.18s-32.26-.08-32.26-.18,14.44-.19,32.26-.19S185.46,400.2,185.46,400.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,409.93c0,.1-14.44.18-32.26.18s-32.26-.08-32.26-.18,14.44-.19,32.26-.19S185.46,409.83,185.46,409.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,419.55c0,.1-14.44.19-32.26.19s-32.26-.09-32.26-.19,14.44-.18,32.26-.18S185.46,419.45,185.46,419.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,429.17c0,.11-14.44.19-32.26.19s-32.26-.08-32.26-.19,14.44-.18,32.26-.18S185.46,429.07,185.46,429.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,438.8c0,.1-14.44.18-32.26.18s-32.26-.08-32.26-.18,14.44-.19,32.26-.19S185.46,438.69,185.46,438.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,448.42c0,.1-14.44.19-32.26.19s-32.26-.09-32.26-.19,14.44-.19,32.26-.19S185.46,448.32,185.46,448.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,458c0,.11-14.44.19-32.26.19s-32.26-.08-32.26-.19,14.44-.18,32.26-.18S185.46,457.94,185.46,458Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.06,
    y: 404.52,
    width: 14.42,
    height: 2.61,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.34,320.47c.24.31,8.12,1.47,9,3.13s1.94,6,1.57,7.41-4.49,5.16-4.49,5.16l-3.08.46s.65,2.59-1,1.94a26,26,0,0,1-3-1.41l-3.14-3.06h3.59a2.37,2.37,0,0,0,1.8-.84l0-.05a2.24,2.24,0,0,0,.11-2.79l0,0c-1.06-1.38-3.42-.57-3.42-.57l-4.58.09-1.3-4.6L141.88,323l7.72-5.39Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,254.47a4.78,4.78,0,0,1,.15,1.2c.07.88.14,2,.24,3.28.21,2.89.48,6.66.78,10.83s.53,8.06.63,10.84c0,1.39.07,2.52.07,3.3a4.94,4.94,0,0,1-.06,1.21,6.38,6.38,0,0,1-.14-1.21c-.07-.88-.15-2-.24-3.28-.21-2.88-.48-6.66-.78-10.83s-.53-8.06-.63-10.84c0-1.39-.07-2.52-.07-3.29A6.06,6.06,0,0,1,64.51,254.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.29 298.7 57.09 309.57 64.15 301.16 56.44 290.61 47.29 298.7",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88,266.77c0,.8,1.71,20.73,1.71,20.73L65,295.78l4.47,4.09,42.9,2.65,1.65-4.86c1.27-6.3,5.18-23.15,5.92-30.49s0-26.18,0-26.18l-14.14-4L93.4,258.39,82.91,235l-15.16,3.66Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.07,240.83s5.82.47,8.75,7.85,9.92,42.19,10.44,42.56,8.57,20,8.57,20l-10.18,6.35s-10.46-12.4-12.36-19.05-5.78-20.21-5.78-20.21l-1.25-10.2Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,256.38a8.08,8.08,0,0,1,0,1.35c-.07.87-.19,2.13-.38,3.68-.36,3.1-1,7.36-1.88,12s-1.93,8.87-2.75,11.88c-.41,1.5-.76,2.71-1,3.55a5.93,5.93,0,0,1-.46,1.27,7.31,7.31,0,0,1,.26-1.33c.23-.94.52-2.15.87-3.58.72-3,1.68-7.23,2.59-11.89s1.57-8.91,2-12c.21-1.46.39-2.69.54-3.65A5.73,5.73,0,0,1,122,256.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,238.32s-5.78,1.25-8,3.29c-3,2.83-23.65,23.49-27.72,29.87s.57,12,.57,12l12.34,16.19,11-9.85L50.47,278l17.75-15.51Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.17,275.31a8.43,8.43,0,0,1,4.39.44,8.44,8.44,0,0,1,3.83,2.16c-.09.14-1.72-1-4-1.67S42.17,275.47,42.17,275.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.26,239.33,62.71,277.1l3.71,11.3c2-21.38,10.08-51.81,10.08-51.81S68.43,235.4,65.26,239.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.48,299.86l-2.9-.69a10.46,10.46,0,0,1,3.79-1.39c1.56-.07,3.2,1.45,3.64-1.29,0,0-4.19-1.93-6.65-.76s-8.69,5.12-11.21,5.43l-7.55,7.9s2.91,3.42,5.62,3,8.42-4.5,8.42-4.5l3.27-.24,5.22,1.93a1.16,1.16,0,0,0,.07-1.69c-.8-.94-4.32-1.95-4.32-1.95l-2.63-.78,2.65-.51s4.29,2.15,6.08,1.26a3.42,3.42,0,0,0,2-2.45Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.92,301.81a4.56,4.56,0,0,0,1.74-.12,9.18,9.18,0,0,1,1.84-.18,8.36,8.36,0,0,1,2.18.54,34,34,0,0,1,3.76,1.79,9.44,9.44,0,0,0,1.57.76,7.15,7.15,0,0,0-1.43-1,24.57,24.57,0,0,0-3.77-1.91,7.57,7.57,0,0,0-2.3-.53,7.71,7.71,0,0,0-1.9.26C71.57,301.69,70.92,301.75,70.92,301.81Z",
    style: {
      fill: "#ff9a6c"
    }
  })));
};
export { SvgProcessing as ReactComponent };
export default "/adb211800e88259babadf31eb9a85cf6.svg";